<template>
  <div>
    <div class="flex justify-between text-gray-700">
      <span>
        {{ audit.title }}
      </span>
      <span :class="`text-${color}-600 font-bold`">
        {{ audit.displayValue }}
      </span>
    </div>
    <div class="text-gray-600">
      <div v-show="showMore === true" class="ml-2">
        <p v-html="renderMarkdownLinks(audit.wordpressTip)" class="my-2"></p>
        <p v-html="renderMarkdownLinks(audit.description)" class="my-2"></p>
      </div>
      <span
        v-show="showMore !== true"
        @click="() => (showMore = true)"
        class="text-blue-600 cursor-pointer"
      >
        {{ $t("generic.expandText:more") }}
      </span>
      <span
        v-show="showMore === true"
        @click="() => (showMore = false)"
        class="text-blue-600 cursor-pointer"
      >
        {{ $t("generic.expandText:close") }}
      </span>
    </div>
  </div>
</template>

<script>
import { getColorForScore } from "@/utils/pagespeed";
import { renderMarkdownLinks } from "@/utils/markdown";

export default {
  name: "PagespeedAuditOpportunityItem",
  props: {
    audit: { type: Object, required: true },
  },
  data() {
    return {
      showMore: false,
    };
  },
  computed: {
    color() {
      return getColorForScore(this.audit.score);
    },
  },
  methods: {
    renderMarkdownLinks,
  },
};
</script>

<style></style>
